import { useEffect, useState } from "react";
import axios, { AxiosResponse } from 'axios';

export interface IBaseResourceData {
    id: number,
    label: string,
    name: string,
    status: string,
    city: string,
    company: string,
    riskLevel: string,
    type: string,
    department: string,
}

export interface IApplicationData extends IBaseResourceData {
    applicationName: string,
}

export interface IServiceData extends IBaseResourceData {
}

export interface IEmployeeData extends IBaseResourceData {
    sapId: string,
    hrId: string,
    businessUnit: string,
    mpkNumber: string,
    registrationNumber: string,
    employeeCompany: string,
    givenName: string,
    surname: string,
}

export interface IDataSetData extends IBaseResourceData {
}

export interface IBusinessProcessData extends IBaseResourceData {
}

export type IResourceData = IApplicationData | IServiceData | IEmployeeData | IDataSetData | IBusinessProcessData

export interface IResourcesData {
    rows: IResourceData[]
    totalSize: number,
    errorMessage: string,
    warningsMessages: string[],

    searchText: string;
}

interface IGetResourcesForTableRequest {
    kind: 'Application' | 'ServiceAsset' | 'BusinessProcess' | 'DataSet' | 'Employee' | 'PersonProfile',

    skip: number,
    take: number,

    dir: 'Asc' | 'Desc',
    orderBy: string,

    search: string,
    searchFields: string[],

    filters: string,
};

type GetResourcesForTableApi = () => [
    (request: IGetResourcesForTableRequest) => void,
    IResourcesData,
    boolean,
    boolean
];

export const useGetResourceGridApi: GetResourcesForTableApi = () => {
    const [request, setRequest] = useState<IGetResourcesForTableRequest>(null);
    const [data, setData] = useState<IResourcesData>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            try {
                const searchText = request.search;
                const result: AxiosResponse<IResourcesData> = await axios('/Resources/GetDataForGrid/', {
                    params: {
                        kind: request.kind,
                        skip: request.skip,
                        take: request.take,
                        dir: request.dir,
                        orderBy: request.orderBy,
                        search: searchText,
                        searchFields: request.searchFields.join(','),
                        filters: request.filters,
                    }
                });
                const data = result.data;

                data.searchText = searchText;
                setData(data);
            } catch (error) {
                console.error(error);
                setIsError(true);
            }
            setIsLoading(false);
        };

        if (!request)
            return;

        fetchData();
    }, [request]);
    return [setRequest, data, isLoading, isError];
}
